// La hora de Madrid en el cliente, en un solo sitio (O-009). La zona es una regla
// del negocio: fichaje, cronometro y reuniones se leen siempre en hora de Madrid,
// este donde este el navegador.

const HHMM = { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Madrid" };

// "14:47" de un instante. Sin instante devuelve `vacio`, que pone cada pantalla
// a la vista en la llamada: "--:--" en los contadores, "" en las reuniones y null
// en Fichar ahora, que con null no pinta la linea.
export const hhmm = (iso, vacio) => (iso ? new Date(iso).toLocaleTimeString("es-ES", HHMM) : vacio);

// Una duracion en milisegundos como "01:02:03"; lo negativo cuenta como cero.
export const hhmmss = ms => {
  const t = Math.max(0, Math.floor(ms / 1000));
  return `${String(Math.floor(t / 3600)).padStart(2, "0")}:`
       + `${String(Math.floor(t % 3600 / 60)).padStart(2, "0")}:`
       + `${String(t % 60).padStart(2, "0")}`;
};
